































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import OverlayStore from '@/modules/common/layout/store/overlay.store'
import { ErrorMessages, FlushMessages } from '@/modules/common/layout/models/types/Messages'
import BannerMessage from '@/modules/common/layout/components/shared/notification/BannerMessage.vue'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import MessageBoardCarousel from '@/modules/common/message-board/components/panel/MessageBoardCarousel.vue'
import InitialPropsStore from '@/modules/common/layout/store/initial-props.store'
import {
  MessageBoardCollection,
  MessageBoardCollectionModel
} from '@/modules/common/message-board/models/message-board-collection.model'
import MessageBoard from '@/modules/common/message-board/components/shared/MessageBoard.vue'
import AlertNotification from '@/modules/notification/components/panel/AlertNotification.vue'
import PanelContentItemLatencyAlarmMessage
  from '@/modules/content-campaign/components/panel/PanelContentItemLatencyAlarmMessage.vue'

export type OverHeaderPropsType = Record<string, any> & { showMessage: boolean }

@Component({
  components: {
    PanelContentItemLatencyAlarmMessage,
    AlertNotification,
    MessageBoard,
    MessageBoardCarousel,
    Heading,
    BannerMessage
  }
})
export default class MainLayout extends Vue {
  constructor(
    protected readonly overlayStore: OverlayStore,
    protected readonly initialProps: InitialPropsStore
  ) {
    super()
  }

  @Prop() errors!: ErrorMessages
  @Prop() flush!: FlushMessages
  //-----
  @Prop() message_board!: MessageBoardCollectionModel
  @Prop({ default: () => [] }) appendMessages !: MessageBoardCollection[]
  //-----
  @Prop() page_header?: String
  @Prop() page_sub_header?: String
  @Prop() header_icon?: String
  @Prop() over_header ?: Function
  @Prop({ default: () => ({ showMessage: false }) }) over_header_props ?: OverHeaderPropsType

  //Hooks
  mounted() {
    this.initialProps.isMounted = true
    //@ts-ignore
    this.initialProps.initialProps = this.$props
  }

}
